// Language management
class LanguageManager {
  constructor() {
    this.currentLang = this.getLanguageFromURL() || localStorage.getItem('language') || 'ar';
    this.translations = {};
    this.init();
  }

  async init() {
    await this.loadTranslations();
    // For static site, just set the language without URL changes
    this.setLanguage(this.currentLang);
    this.setupLanguageSwitcher();
  }

  async loadTranslations() {
    try {
      // Determine the correct path based on current page location
      const isViewPage = window.location.pathname.includes('/views/');
      const langPath = isViewPage ? '../lang/' : 'lang/';
      
      const enResponse = await fetch(langPath + 'en.json');
      const arResponse = await fetch(langPath + 'ar.json');
      
      if (enResponse.ok && arResponse.ok) {
        this.translations.en = await enResponse.json();
        this.translations.ar = await arResponse.json();
      } else {
        console.warn('Language files not found, using default content');
        this.translations.en = {};
        this.translations.ar = {};
      }
    } catch (error) {
      console.warn('Error loading translations, using default content:', error);
      this.translations.en = {};
      this.translations.ar = {};
    }
  }

  getLanguageFromURL() {
    const path = window.location.pathname;
    if (path.startsWith('/ar/') || path === '/ar') {
      return 'ar';
    } else if (path.startsWith('/en/') || path === '/en') {
      return 'en';
    }
    return null;
  }

  setLanguage(lang) {
    this.currentLang = lang;
    localStorage.setItem('language', lang);
    
    // Set document direction
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
    
    // Update all translatable elements
    this.updateContent();
    
    // Update language switcher
    this.updateLanguageSwitcher();
  }

  updateURL(lang) {
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    const currentHash = window.location.hash;
    
    // Remove existing language prefix
    let newPath = currentPath.replace(/^\/(en|ar)/, '');
    
    // Add new language prefix
    if (newPath === '') {
      newPath = `/${lang}`;
    } else {
      newPath = `/${lang}${newPath}`;
    }
    
    // Construct new URL
    const newURL = newPath + currentSearch + currentHash;
    
    // Update browser history without reloading the page
    window.history.pushState({ lang }, '', newURL);
  }

  updateContent() {
    const elements = document.querySelectorAll('[data-translate]');
    elements.forEach(element => {
      const key = element.getAttribute('data-translate');
      const translation = this.getTranslation(key);
      if (translation) {
        element.textContent = translation;
      }
    });

    // Update placeholders
    const inputs = document.querySelectorAll('[data-translate-placeholder]');
    inputs.forEach(input => {
      const key = input.getAttribute('data-translate-placeholder');
      const translation = this.getTranslation(key);
      if (translation) {
        input.placeholder = translation;
      }
    });

    // Update Choices dropdowns using your custom translation solution
    this.updateChoicesTranslations();
  }

  getTranslation(key) {
    const keys = key.split('.');
    let translation = this.translations[this.currentLang];
    
    for (const k of keys) {
      if (translation && translation[k]) {
        translation = translation[k];
      } else {
        return null;
      }
    }
    
    return translation;
  }

  setupLanguageSwitcher() {
    // New: single toggle button for header
    const langToggle = document.getElementById('lang-toggle');
    const langToggleText = document.getElementById('lang-toggle-text');
    // New: single toggle button for mobile sidebar
    const langToggleMobile = document.getElementById('lang-toggle-mobile');
    const langToggleMobileText = document.getElementById('lang-toggle-mobile-text');

    const updateButton = (btn, textSpan) => {
      if (!btn || !textSpan) return;
      // Show the other language as the button text
      textSpan.textContent = this.currentLang === 'ar' ? 'EN' : 'AR';
    };

    updateButton(langToggle, langToggleText);
    updateButton(langToggleMobile, langToggleMobileText);

    if (langToggle) {
      langToggle.onclick = (e) => {
        e.preventDefault();
        const nextLang = this.currentLang === 'ar' ? 'en' : 'ar';
       // Save the new language to localStorage
       localStorage.setItem('language', nextLang);
       // Reload the page with the new language
       window.location.reload();
        
      };
    }
    if (langToggleMobile) {
      langToggleMobile.onclick = (e) => {
        e.preventDefault();
        const nextLang = this.currentLang === 'ar' ? 'en' : 'ar';
        // this.setLanguage(nextLang);
        // updateButton(langToggle, langToggleText);
        // updateButton(langToggleMobile, langToggleMobileText);
        
        // // Close the sidebar when switching language from mobile
        // const sidebar = document.getElementById('rightSidebar');
        // const overlay = document.getElementById('overlay');
        // if (sidebar && overlay) {
        //   sidebar.classList.remove('open');
        //   overlay.classList.remove('show');
        //   document.body.style.overflow = '';
        // }
         // Save the new language to localStorage
         localStorage.setItem('language', nextLang);
         // Reload the page with the new language
         window.location.reload();
      };
    }
  }

  updateLanguageSwitcher() {
    // Update the toggle button text in both header and sidebar
    const langToggleText = document.getElementById('lang-toggle-text');
    const langToggleMobileText = document.getElementById('lang-toggle-mobile-text');
    if (langToggleText) {
      langToggleText.textContent = this.currentLang === 'ar' ? 'EN' : 'AR';
    }
    if (langToggleMobileText) {
      langToggleMobileText.textContent = this.currentLang === 'ar' ? 'EN' : 'AR';
    }
  }

  updateChoicesTranslations() {
    // Update Choices dropdown placeholders and text using your custom translation solution
    const choicesElements = document.querySelectorAll('.js-choice');
    choicesElements.forEach(element => {
      if (element.choicesInstance) {
        const choices = element.choicesInstance;
        
        // Update placeholder if it has a translation key
        const placeholderKey = element.getAttribute('data-translate-placeholder');
        if (placeholderKey) {
          const translation = this.getTranslation(placeholderKey);
          if (translation) {
            choices.setChoiceByValue('');
            choices.config.placeholderValue = translation;
          }
        } else {
          // Use default form.choose_subject if no specific placeholder key
          const translation = this.getTranslation('form.choose_subject');
          if (translation) {
            choices.setChoiceByValue('');
            choices.config.placeholderValue = translation;
          }
        }
        
        // Update itemSelectText
        const itemSelectText = this.getTranslation('form.press_to_select') || 'Press to select';
        choices.config.itemSelectText = itemSelectText;
      }
    });
  }
}

// Mobile sidebar management
class MobileSidebar {
  constructor() {
    this.toggleBtn = document.getElementById('toggleSidebarBtn');
    this.closeBtn = document.getElementById('closeSidebarBtn');
    this.sidebar = document.getElementById('rightSidebar');
    this.overlay = document.getElementById('overlay');
    this.init();
  }

  init() {
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener('click', () => this.openSidebar());
    }
    
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.closeSidebar());
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeSidebar());
    }

    // Close sidebar when clicking on a link
    const sidebarLinks = document.querySelectorAll('#rightSidebar .nav-link');
    sidebarLinks.forEach(link => {
      link.addEventListener('click', () => this.closeSidebar());
    });
  }

  openSidebar() {
    this.sidebar.classList.add('open');
    this.overlay.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  closeSidebar() {
    this.sidebar.classList.remove('open');
    this.overlay.classList.remove('show');
    document.body.style.overflow = '';
  }
}

// Smooth scrolling for navigation links
class SmoothScroll {
  constructor() {
    this.init();
  }

  init() {
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }
}

// Animation on scroll
class ScrollAnimations {
  constructor() {
    this.init();
  }

  init() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach(el => observer.observe(el));
  }
}

// Preloader
class Preloader {
  constructor() {
    this.loader = document.getElementById('landing-loader');
    this.init();
  }

  init() {
    if (this.loader) {
      // Hide loader after a short delay regardless of other loading
      setTimeout(() => {
        this.hideLoader();
      }, 1000);
      
      // Also hide on window load event
      window.addEventListener('load', () => {
        this.hideLoader();
      });
    }
  }

  hideLoader() {
    if (this.loader && this.loader.style.display !== 'none') {
      this.loader.style.opacity = '0';
      setTimeout(() => {
        this.loader.style.display = 'none';
      }, 300);
    }
  }
}

// Active navigation management
class ActiveNavigation {
  constructor() {
    this.init();
  }

  init() {
    this.updateActiveNav();
    window.addEventListener('scroll', () => this.updateActiveNav());
    window.addEventListener('load', () => this.updateActiveNav());
  }

  updateActiveNav() {
    const currentPath = window.location.pathname;
    const currentHash = window.location.hash || '#home';
    
    // Remove active class from all nav items
    this.removeActiveClasses();
    
    // Add active class based on current page/hash
    this.addActiveClass(currentPath, currentHash);
  }

  removeActiveClasses() {
    // Remove from header nav
    const headerNavLinks = document.querySelectorAll('header a');
    headerNavLinks.forEach(link => {
      link.classList.remove('active', 'text-purple-700');
      link.classList.add('text-gray-600');
    });

    // Remove from sidebar nav
    const sidebarNavLinks = document.querySelectorAll('#rightSidebar .nav-link, #rightSidebar .dropdown-item');
    sidebarNavLinks.forEach(link => {
      link.classList.remove('active');
    });
  }

  addActiveClass(path, hash) {
    // Determine current page/section
    let currentSection = 'home';
    
    // Check for page-based navigation (both development and production URLs)
    if (path.includes('/restaurant') || path.includes('/views/restaurant')) {
      currentSection = 'register-restaurant';
    } else if (path.includes('/deliver') || path.includes('/views/deliver')) {
      currentSection = 'register-deliver';
    } else if (path.includes('/vendor') || path.includes('/views/vendor')) {
      currentSection = 'register-vendor';
    } else if (path.includes('/ngo') || path.includes('/views/ngo')) {
      currentSection = 'register-ngo';
    } else if (path.includes('/about-us') || path.includes('/views/about-us')) {
      currentSection = 'about-us';
    } else if (path.includes('/contact-us') || path.includes('/views/contact-us')) {
      currentSection = 'contact-us';
    } else if (path.includes('/terms') || path.includes('/views/terms')) {
      currentSection = 'terms';
    } else if (path.includes('/privacy') || path.includes('/views/privacy')) {
      currentSection = 'privacy';
    } else if (path.includes('/about') || hash === '#about-us') {
      currentSection = 'about-us';
    } else if (path === '/' || path === '/index.html' || hash === '#home') {
      currentSection = 'home';
    }

    // Add active class to header navigation
    const headerLinks = document.querySelectorAll('header a');
    headerLinks.forEach(link => {
      const linkHref = link.getAttribute('href');
      if (!linkHref) return;
      
      let isActive = false;
      
      // Check if this link matches the current section
      switch (currentSection) {
        case 'home':
          isActive = linkHref === '/index.html' || linkHref === '/' || linkHref === '#home';
          break;
        case 'register-restaurant':
          isActive = linkHref.includes('/restaurant') || linkHref.includes('/views/restaurant');
          break;
        case 'register-deliver':
          isActive = linkHref.includes('/deliver') || linkHref.includes('/views/deliver');
          break;
        case 'register-vendor':
          isActive = linkHref.includes('/vendor') || linkHref.includes('/views/vendor');
          break;
        case 'register-ngo':
          isActive = linkHref.includes('/ngo') || linkHref.includes('/views/ngo');
          break;
        case 'about-us':
          isActive = linkHref.includes('/about-us') || linkHref.includes('/views/about-us') || linkHref === '#about-us';
          break;
        case 'contact-us':
          isActive = linkHref.includes('/contact-us') || linkHref.includes('/views/contact-us');
          break;
        case 'terms':
          isActive = linkHref.includes('/terms') || linkHref.includes('/views/terms');
          break;
        case 'privacy':
          isActive = linkHref.includes('/privacy') || linkHref.includes('/views/privacy');
          break;
      }
      
      if (isActive) {
        link.classList.remove('text-gray-600');
        link.classList.add('text-purple-700', 'active');
      }
    });

    // Handle "Work With Us" dropdown button active state
    const workWithUsButton = document.querySelector('header .group button');
    if (workWithUsButton) {
      const isWorkWithUsActive = ['register-restaurant', 'register-deliver', 'register-vendor', 'register-ngo'].includes(currentSection);
      if (isWorkWithUsActive) {
        workWithUsButton.classList.remove('text-gray-600');
        workWithUsButton.classList.add('text-purple-700', 'active');
      }
    }

    // Add active class to sidebar navigation
    const sidebarLinks = document.querySelectorAll('#rightSidebar .nav-link, #rightSidebar .dropdown-item');
    sidebarLinks.forEach(link => {
      const linkHref = link.getAttribute('href');
      if (!linkHref) return;
      
      let isActive = false;
      
      // Check if this link matches the current section
      switch (currentSection) {
        case 'home':
          isActive = linkHref === '/index.html' || linkHref === '/' || linkHref === '#home';
          break;
        case 'register-restaurant':
          isActive = linkHref.includes('/restaurant') || linkHref.includes('/views/restaurant');
          break;
        case 'register-deliver':
          isActive = linkHref.includes('/deliver') || linkHref.includes('/views/deliver');
          break;
        case 'register-vendor':
          isActive = linkHref.includes('/vendor') || linkHref.includes('/views/vendor');
          break;
        case 'register-ngo':
          isActive = linkHref.includes('/ngo') || linkHref.includes('/views/ngo');
          break;
        case 'about-us':
          isActive = linkHref.includes('/about-us') || linkHref.includes('/views/about-us');
          break;
        case 'contact-us':
          isActive = linkHref.includes('/contact-us') || linkHref.includes('/views/contact-us');
          break;
        case 'terms':
          isActive = linkHref.includes('/terms') || linkHref.includes('/views/terms');
          break;
        case 'privacy':
          isActive = linkHref.includes('/privacy') || linkHref.includes('/views/privacy');
          break;
      }
      
      if (isActive) {
        link.classList.add('active');
      }
    });

    // Handle "Work With Us" in sidebar active state
    const sidebarWorkWithUs = document.querySelector('#rightSidebar .nav-item .nav-link[data-translate="nav.work_with_us"]');
    if (sidebarWorkWithUs) {
      const isWorkWithUsActive = ['register-restaurant', 'register-deliver', 'register-vendor', 'register-ngo'].includes(currentSection);
      if (isWorkWithUsActive) {
        sidebarWorkWithUs.classList.add('active');
      }
    }
  }
}

// URL utility for handling development vs production URLs
class URLManager {
  static isDevelopment() {
    return window.location.hostname === 'localhost' || 
           window.location.hostname === '127.0.0.1' || 
           window.location.port !== '';
  }
  
  static getPageURL(page) {
    if (this.isDevelopment()) {
      return `/views/${page}.html`;
    } else {
      return `/${page}`;
    }
  }
  
  static getHomeURL() {
    if (this.isDevelopment()) {
      return '/index.html';
    } else {
      return '/';
    }
  }
  
  static updateNavigationLinks() {
    // Update header links
    const headerLinks = document.querySelectorAll('header a[href]');
    headerLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href === '/restaurant') {
        link.href = this.getPageURL('restaurant');
      } else if (href === '/deliver') {
        link.href = this.getPageURL('deliver');
      } else if (href === '/vendor') {
        link.href = this.getPageURL('vendor');
      } else if (href === '/ngo') {
        link.href = this.getPageURL('ngo');
      } else if (href === '/about-us') {
        link.href = this.getPageURL('about-us');
      } else if (href === '/contact-us') {
        link.href = this.getPageURL('contact-us');
      } else if (href === '/terms') {
        link.href = this.getPageURL('terms');
      } else if (href === '/privacy') {
        link.href = this.getPageURL('privacy');
      } else if (href === '/') {
        link.href = this.getHomeURL();
      }
    });
    
    // Update sidebar links
    const sidebarLinks = document.querySelectorAll('#rightSidebar a[href]');
    sidebarLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href === '/restaurant') {
        link.href = this.getPageURL('restaurant');
      } else if (href === '/deliver') {
        link.href = this.getPageURL('deliver');
      } else if (href === '/vendor') {
        link.href = this.getPageURL('vendor');
      } else if (href === '/ngo') {
        link.href = this.getPageURL('ngo');
      } else if (href === '/about-us') {
        link.href = this.getPageURL('about-us');
      } else if (href === '/contact-us') {
        link.href = this.getPageURL('contact-us');
      } else if (href === '/terms') {
        link.href = this.getPageURL('terms');
      } else if (href === '/privacy') {
        link.href = this.getPageURL('privacy');
      } else if (href === '/') {
        link.href = this.getHomeURL();
      }
    });
    
    // Update footer links
    const footerLinks = document.querySelectorAll('footer a[href]');
    footerLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href === '/restaurant') {
        link.href = this.getPageURL('restaurant');
      } else if (href === '/deliver') {
        link.href = this.getPageURL('deliver');
      } else if (href === '/vendor') {
        link.href = this.getPageURL('vendor');
      } else if (href === '/ngo') {
        link.href = this.getPageURL('ngo');
      } else if (href === '/about-us') {
        link.href = this.getPageURL('about-us');
      } else if (href === '/contact-us') {
        link.href = this.getPageURL('contact-us');
      } else if (href === '/terms') {
        link.href = this.getPageURL('terms');
      } else if (href === '/privacy') {
        link.href = this.getPageURL('privacy');
      } else if (href === '/') {
        link.href = this.getHomeURL();
      }
    });
  }
}

// Load dropdowns based on current page
function loadPageDropdowns() {
  const currentPath = window.location.pathname;
  
  // Check if RegistrationAPI is available
  if (typeof RegistrationAPI === 'undefined') {
    console.warn('RegistrationAPI not available');
    return;
  }
  
  const registrationAPI = new RegistrationAPI();
  
  // Load dropdowns based on current page
  if (currentPath.includes('/restaurant') || currentPath.includes('/views/restaurant')) {
    // Wait a bit for Choices to initialize
    setTimeout(() => {
      registrationAPI.loadRestaurantDropdowns();
    }, 500);
  } else if (currentPath.includes('/vendor') || currentPath.includes('/views/vendor')) {
    setTimeout(() => {
      registrationAPI.loadVendorDropdowns();
    }, 500);
  } else if (currentPath.includes('/deliver') || currentPath.includes('/views/deliver')) {
    setTimeout(() => {
      registrationAPI.loadDeliverDropdowns();
    }, 500);
  } else if (currentPath.includes('/ngo') || currentPath.includes('/views/ngo')) {
    setTimeout(() => {
      registrationAPI.loadNgoDropdowns();
    }, 500);
  }
}

// Initialize everything when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Update navigation links based on environment
  URLManager.updateNavigationLinks();
  
  // Initialize language manager and make it globally accessible
  const languageManager = new LanguageManager();
  window.languageManager = languageManager;
  
  // Initialize mobile sidebar
  const mobileSidebar = new MobileSidebar();
  
  // Initialize smooth scrolling
  const smoothScroll = new SmoothScroll();
  
  // Initialize scroll animations
  const scrollAnimations = new ScrollAnimations();
  
  // Initialize preloader
  const preloader = new Preloader();
  
  // Initialize active navigation
  const activeNavigation = new ActiveNavigation();
  
  // Initialize phone inputs with intl-tel-input
  // if (typeof initializePhoneInputs === 'function') {
  //     initializePhoneInputs();
  // }
  
  // Initialize Choices
  initializeChoices();
  
  // Setup modal functionality
  setupModalOverlay();
  setupModalKeyboard();
  
  // Also try to initialize phone inputs after a short delay (for dynamic content)
  // setTimeout(() => {
  //   initializePhoneInputs();
  //   initializeChoices();
  // }, 1000);
  
  // Load dropdowns for the current page
  loadPageDropdowns();
});

// Initialize intl-tel-input for all phone fields
function initializePhoneInputs() {
  // Check if intl-tel-input is available
  if (typeof window.intlTelInput === 'undefined') {
    console.warn('intl-tel-input library not loaded');
    return;
  }

  // Check if we're on a page that should have phone inputs
  const currentPath = window.location.pathname;
  const hasPhoneInputs = currentPath.includes('/restaurant') || 
                        currentPath.includes('/deliver') || 
                        currentPath.includes('/vendor') || 
                        currentPath.includes('/ngo') ||
                        currentPath.includes('/views/');

  // Get all phone input fields
  const phoneInputs = document.querySelectorAll('input[type="tel"]');
  
  phoneInputs.forEach(input => {
    try {
      if (input.classList.contains('iti')) {
        return;
      }
  
      const phoneInstance = window.intlTelInput(input, {
        separateDialCode: true,
        utilsScript:'https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js',
      });
      
      // Store the instance on the input element for later access
      input.intlTelInputInstance = phoneInstance;
      
      // // Add validation on form submission
      // const form = input.closest('form');
      // if (form) {
      //   form.addEventListener('submit', (e) => {
      //     if (!phoneInstance.isValidNumber()) {
      //       e.preventDefault();
      //       alert('Please enter a valid phone number');
      //       input.focus();
      //       return false;
      //     }
      //   });
      // }
      
      // // Add input event listener to update the input value
      // input.addEventListener('input', () => {
      //   if (phoneInstance.isValidNumber()) {
      //     const fullNumber = phoneInstance.getNumber();
      //     input.setAttribute('data-full-number', fullNumber);
      //   }
      // });
      
    } catch (error) {
      console.error('Error initializing intl-tel-input for', input.id, error);
    }
  });
}

// Global function to get full phone number from any input
window.getPhoneNumber = function(inputId) {
  const input = document.getElementById(inputId);
  if (input && input.intlTelInputInstance) {
    return input.intlTelInputInstance.getNumber();
  }
  return null;
};

// Global function to validate phone number
window.isValidPhoneNumber = function(inputId) {
  const input = document.getElementById(inputId);
  if (input && input.intlTelInputInstance) {
    return input.intlTelInputInstance.isValidNumber();
  }
  return false;
};

// Initialize Choices for select elements
function initializeChoices() {
  if (typeof Choices === 'undefined') {
    console.warn('Choices library not loaded');
    return;
  }

  const elements = document.querySelectorAll('.js-choice');
  
  elements.forEach(element => {
    if (element && !element.choicesInstance) {
      try {
        
        const lang = localStorage.getItem('language') || 'en';

        const placeholders = {
          en: 'Select an option',
          ar: 'اختر خيارًا',
        };
        const choices = new Choices(element, {
          searchEnabled: true,
          shouldSort: false,
          placeholder: true,
          placeholderValue: placeholders[lang] || placeholders.en,
          allowHTML: true,
          
        });
        element.choicesInstance = choices;
      } catch (error) {
        console.error('Error initializing Choices for', element.id, error);
      }
    }
  });
}




// Modal management functions
function openRestaurantModal() {
  const modal = document.getElementById('restaurantModal');
  if (modal) {
    modal.classList.add('show');
    document.body.style.overflow = 'hidden';
    // Initialize form elements after modal is shown
    setTimeout(() => {
      // initializePhoneInputs();
      // initializeChoices();
      // Load dropdowns after Choices is initialized
      if (typeof RegistrationAPI !== 'undefined') {
        const registrationAPI = new RegistrationAPI();
        registrationAPI.loadRestaurantDropdowns();
      }
    }, 100);
  }
}

function openVendorModal() {
  const modal = document.getElementById('vendorModal');
  if (modal) {
    modal.classList.add('show');
    document.body.style.overflow = 'hidden';
    // Initialize form elements after modal is shown
    setTimeout(() => {
      // initializePhoneInputs();
      // initializeChoices();
      // Load dropdowns after Choices is initialized
      if (typeof RegistrationAPI !== 'undefined') {
        const registrationAPI = new RegistrationAPI();
        registrationAPI.loadVendorDropdowns();
      }
    }, 100);
  }
}

function openDeliverModal() {
  const modal = document.getElementById('deliverModal');
  if (modal) {
    modal.classList.add('show');
    document.body.style.overflow = 'hidden';
    // Initialize form elements after modal is shown
    setTimeout(() => {
      // initializePhoneInputs();
      // initializeChoices();
      // Load dropdowns after Choices is initialized
      if (typeof RegistrationAPI !== 'undefined') {
        const registrationAPI = new RegistrationAPI();
        registrationAPI.loadDeliverDropdowns();
      }
    }, 100);
  }
}

function openNgoModal() {
  const modal = document.getElementById('ngoModal');
  if (modal) {
    modal.classList.add('show');
    document.body.style.overflow = 'hidden';
    // Initialize form elements after modal is shown
    setTimeout(() => {
      // initializePhoneInputs();
      // initializeChoices();
      // Load dropdowns after Choices is initialized
      if (typeof RegistrationAPI !== 'undefined') {
        const registrationAPI = new RegistrationAPI();
        registrationAPI.loadNgoDropdowns();
      }
    }, 100);
  }
}

// Generic function to open specific modal based on data attribute
function openSpecificModal(button) {
  const formType = button.getAttribute('data-form-type');
  
  switch (formType) {
    case 'restaurant':
      openRestaurantModal();
      break;
    case 'vendor':
      openVendorModal();
      break;
    case 'deliver':
      openDeliverModal();
      break;
    case 'ngo':
      openNgoModal();
      break;
    default:
      console.warn('Unknown form type:', formType);
  }
}

// Close modal function
function closeModal(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.remove('show');
    document.body.style.overflow = '';
  }
}

// Close modal when clicking outside
function setupModalOverlay() {
  const modals = document.querySelectorAll('.modal');
  modals.forEach(modal => {
    const overlay = modal.querySelector('.modal-overlay');
    if (overlay) {
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          closeModal(modal.id);
        }
      });
    }
  });
}

// Close modal with escape key
function setupModalKeyboard() {
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const openModal = document.querySelector('.modal.show');
      if (openModal) {
        closeModal(openModal.id);
      }
    }
  });
}

// Make functions globally available
window.openRestaurantModal = openRestaurantModal;
window.openVendorModal = openVendorModal;
window.openDeliverModal = openDeliverModal;
window.openNgoModal = openNgoModal;
window.openSpecificModal = openSpecificModal;
window.closeModal = closeModal;